<div class="dialogContainer">
  <div class="content">
    <div class="informationRow">
      <label class="informationLabel">Enter Contact Info</label>
    </div>
    <div class="inputRow">
      <mat-form-field class="inputField">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="deliveryContactName" type="text"/>
      </mat-form-field>
    </div>
    <div class="inputRow">
      <mat-form-field class="inputField">
        <mat-label>Phone Number</mat-label>
        <input matInput [(ngModel)]="deliveryPhone" type="text"/>
      </mat-form-field>
    </div>

    <div class=" buttonRow">
      <span class="spacer"></span>
      <button (click)="cancel()" matButton="elevated" class="inputButton warn-button">
            <span>
                <label class="buttonLabel">Cancel</label>
            </span>
        </button>
        <button [disabled]="isEntityFrozen || isBusy" (click)="submit()" matButton="elevated" class="inputButton primary-button">
            <span>
                <label class="buttonLabel">Submit</label>
            </span>
      </button>
    </div>
  </div>
</div>
